// src/pages/chat/chat.hooks.ts
import { useCallback, useEffect, useState } from "react";
import { ENVIRONMENT } from "../../env";

const log = (...args: any[]) => {
    if (ENVIRONMENT === "DEV") console.log("[chat.hooks.ts]", ...args);
};

export const useChat = () => {
    const [isFullScreenRecordingMode, setIsFullScreenRecordingMode] = useState(
        false,
    );

    useEffect(() => {
        log("isFullScreenRecordingMode =", isFullScreenRecordingMode);
    }, [isFullScreenRecordingMode]);

    // Kept for other callers (but we no longer use it for CTA)
    const handleToggleFullScreenRecordingMode = useCallback(() => {
        setIsFullScreenRecordingMode((v) => {
            const next = !v;
            log("toggleFullScreen:", v, "->", next);
            return next;
        });
    }, []);

    const handleNotificationClick = useCallback(() => {
        log("Notifications clicked");
    }, []);

    const handleProfileClick = useCallback(() => {
        log("Profile clicked");
    }, []);

    const handleBack = useCallback(() => {
        log("Back clicked");
    }, []);

    return {
        isFullScreenRecordingMode,
        handleToggleFullScreenRecordingMode,
        setIsFullScreenRecordingMode,
        handleNotificationClick,
        handleProfileClick,
        handleBack,
    };
};
